import {Component, OnDestroy, OnInit, ViewChild, ViewContainerRef} from '@angular/core';
import {LineItem, ReturnData, ReturnsModel, Serial} from '../../../../models/returns.model';
import {DickerSelectListItem} from '../../../../models/check-out.model';
import {Subject} from 'rxjs';
import {BreadcrumbComponent} from '../../../../breadcrumb/breadcrumb.component';
import {ActivatedRoute, Router} from '@angular/router';
import {MyoderService} from '../../../../my-orders/shared/myoder.service';
import {CommonService} from '../../../../services';
import {map, switchMap, takeUntil, tap} from 'rxjs/operators';

@Component({
  selector: 'app-return-details',
  templateUrl: './return-details.component.html',
  styleUrls: ['./return-details.component.css']
})
export class ReturnsDetailsComponent implements OnInit, OnDestroy {

  title = 'Returns';

  originalOrders: LineItem[] = [];
  ordersForReturn: LineItem[] = [];
  fullOrders: LineItem[] = [];
  orderNumber: string;
  orderSuffix: string = '';
  comments: string = '';
  reasonList: DickerSelectListItem[];
  goodsConditionList: DickerSelectListItem[];
  returnList: DickerSelectListItem[] = [
    {
      text: 'Please select',
      value: '',
      displayText: 'Please select',
      selected: true
    },
    {
      text: 'Full Return',
      value: 'full',
      displayText: 'Full Return',
      selected: false
    },
    {
      text: 'Partial Return',
      value: 'partial',
      displayText: 'Partial Return',
      selected: false
    },
  ];
  attachments: FileList;
  imageFile: File;
  selectedReason: string;
  selectedCondition: string;
  returnOption: string = '';
  chooseFileMessage: string = 'No file chosen';
  venderRefNumber: string;
  formData = new FormData();

  loadContent = false;
  finishSending = true;
  disableSending = true;

  total = 0;
  ngUnsubscribe: Subject<void> = new Subject<void>();

  @ViewChild(BreadcrumbComponent) sample: BreadcrumbComponent;
  @ViewChild('entry', {read: ViewContainerRef})
  entry: ViewContainerRef;


  constructor(
    private router: Router,
    private activatedRouter: ActivatedRoute,
    private orderService: MyoderService,
    private commonService: CommonService
  ) {
  }

  ngOnInit() {

    $('#levelOne').animate({scrollLeft: 250}, 400);

    this.activatedRouter.paramMap.pipe(
      takeUntil(this.ngUnsubscribe),
      tap(() => {
        this.loadContent = false;
      }),
      switchMap((params) => {
        const suffix = params.has('orderSuffix') ? params.get('orderSuffix') : '';
        return this.orderService.getReturnOrderDetails(params.get('orderNo'), suffix).pipe(
          switchMap((res: LineItem[]) => {
            return this.orderService.getReturnsDropdownLists().pipe(
              map((dropdownList: ReturnsModel) => {
                return {
                  orderNo: params.get('orderNo'),
                  orderSuffix: suffix,
                  lineItems: res,
                  dropdownList: dropdownList
                };
              })
            );
          })
        );
      })
    ).subscribe((res) => {
      // @ts-ignore
      const {orderNo, orderSuffix, lineItems, dropdownList} = res;
      this.orderNumber = orderNo;
      this.orderSuffix = orderSuffix;

      this.originalOrders = lineItems;
      this.fullOrders = lineItems.slice();
      this.disableSending = false;
      this.originalOrders.forEach(x => x.returnQty = x.orderQty);

      if (!this.originalOrders.length) {
        this.commonService.implementToast('Order not found or no shipped item found', 'Info');
      }
      this.goodsConditionList = dropdownList.conditionOfGoods;
      this.reasonList = dropdownList.reasonOptions;
      this.venderRefNumber = dropdownList.venderRefNumber;

      this.returnOption = '';
      this.comments = '';
      this.imageFile = null;
      this.chooseFileMessage = 'No file chosen';

      //setup for default selection
      this.selectedReason = this.reasonList.filter(r => r.selected === true)[0].text;
      this.selectedCondition = this.goodsConditionList.filter(g => g.selected === true)[0].text;
      this.loadContent = true;
    });
  }

  getTotal(): string {
    let total = 0;
    if (this.returnOption == 'partial') {
      this.originalOrders.forEach((value, index) => {
        if (value.selected) {
          total += (Number(value.unitValue) * Number(value.returnQty));
        }
      });
    } else {
      this.originalOrders.forEach((value, index) => {
        total += (Number(value.unitValue) * Number(value.returnQty));
      });
    }
    return total.toString();
  }

  onSelectFile(event: any) {
    this.attachments = event.target.files;

    if (this.attachments.length > 0) {
      this.chooseFileMessage = this.attachments.length === 1 ? this.attachments[0].name : this.attachments.length.toString() + ' files selected';
      this.imageFile = event.target.files[0];

      this.formData.append(this.imageFile.name, this.imageFile);
    } else {
      this.chooseFileMessage = 'No file chosen';
    }
  }

  onReturnSelect(value: string) {
    // tslint:disable-next-line:triple-equals
    if (value === 'partial') {
      this.originalOrders.forEach(x => x.returnQty = '0');
    } else {
      this.originalOrders.forEach(x => x.returnQty = x.orderQty);
    }
  }

  onSerialsChange(value: boolean, serial: Serial, order: LineItem) {
    serial.selected = value;
    const selectedCount = order.serials.filter(s => s.selected === true).length;
    order.returnQty = String(selectedCount);
    order.selected = selectedCount > 0;
  }

  onStockCodeChange(value: boolean, order: LineItem) {
    // if (order.serials.length === 0 && Number(order.returnQty) === 0 && value === true) {
    //   this.commonService.implementToast(`If a line has been selected for partial return, qty field must be greater than zero`, 'Info');
    // }


    // serialized orders
    if (order.serials.length > 0) {
      order.serials.forEach(s => s.selected = value);
      const selectedCount = order.serials.filter(s => s.selected === true).length;
      order.returnQty = String(selectedCount);
    } else {
      // non-serialized orders && non-editable qty
      if (Number(order.orderQty) === 1) {
        order.selected = value;
        if (value) {
          order.returnQty = order.orderQty;
        } else {
          order.returnQty = '0';
        }
      } else {
        // non-serialized orders && editable qty
        if (value) {
          if (Number(order.returnQty) === 0) {
            this.commonService.implementToast(`If a line has been selected for partial return, qty field must be greater than zero`, 'Info');
          } else if (Number(order.returnQty) > Number(order.orderQty)) {
            this.commonService.implementToast(`Quantity must be less or equal to ${order.orderQty}`, 'Info');
            order.selected = value;
          }
          order.selected = value;
        }
      }
    }
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  sendReturnForm() {
    if (this.validateForm()) {
      let returnData = {} as ReturnData;
      this.ordersForReturn = []; //initialize array to empty

      if (this.returnOption === 'full') {  //full returns
        this.originalOrders.forEach(order => {

          this.ordersForReturn.push(order);
        });

      } else {  //partial returns
        let allOrder = this.originalOrders.map(x => Object.assign({}, x));
        allOrder.filter(x => x.selected === true).forEach(order => {
          let returnItem = {} as LineItem;
          returnItem = order;

          if (returnItem.serials.length > 0) {
            returnItem.serials = returnItem.serials.filter(s => s.selected === true);
            returnItem.returnQty = returnItem.serials.length.toString();
          }

          this.ordersForReturn.push(returnItem);
        });

      }

      returnData.orderNumber = this.orderNumber;
      returnData.orderSuffix = this.orderSuffix;
      returnData.isPartialReturn = this.returnOption === 'full' ? false : true;
      returnData.venderRefNumber = this.venderRefNumber;
      returnData.reasonDetails = this.comments;
      returnData.reason = this.selectedReason;
      returnData.conditionOfGoods = this.selectedCondition;
      returnData.items = this.ordersForReturn;
      //returnData.files = this.attachments;

      this.finishSending = false;

      this.orderService.returnsGetData(returnData, this.imageFile).pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((res: any) => {
            this.finishSending = true;
            if (res.status) {
              this.disableSending = true;
              this.commonService.implementToast('Returns have been sent successfully', 'Success', true);

              //  setTimeout(() => {
              //   this.router.navigateByUrl('/myAccount');
              //  }, 1000);
            } else {
              // tslint:disable-next-line:no-console
              console.info(res.responseMessage);
              this.commonService.implementToast('Unable to send your returns, please try again later', 'Error');

            }

          },
          (error: any) => {
            console.error(error);
            this.finishSending = true;
          });

    }
  }

  onReturnQtyChange(order: LineItem) {

    const returnQty = Number(order.returnQty);

    // selected order
    if (order.selected) {
      if ((returnQty > Number(order.orderQty))) {
        this.commonService.implementToast(`Quantity must be less or equal to ${order.orderQty}`, 'Info');
      } else if (returnQty === 0) {
        setTimeout(() => {
          order.selected = false;
        }, 500);
      }
    } else {
      if ((returnQty > Number(order.orderQty))) {
        this.commonService.implementToast(`Quantity must be less or equal to ${order.orderQty}`, 'Info');
      } else if (returnQty > 0 && returnQty <= Number(order.orderQty)) {
        setTimeout(() => {
          order.selected = true;
        }, 500);
      }
    }

  }


  validateForm(): boolean {
    if (this.returnOption === 'partial') {

      const selectedOrders = this.originalOrders.filter(m => m.selected);

      if (selectedOrders.length === 0) {
        this.commonService.implementToast(`must select at least one return item`, 'Info');
        return false;
      } else {
        for (let i = 0; i < selectedOrders.length; i++) {
          if (Number(selectedOrders[i].returnQty) === 0) {
            this.commonService.implementToast(`${selectedOrders[i].stockcode} has been selected for partial return, qty field must be greater than zero`, 'Info');
            return false;
          } else if (Number(selectedOrders[i].returnQty) > Number(selectedOrders[i].orderQty)) {
            // this.commonService.showError(`#qty${selectedOrders[i].stockcode}`, `Quantity must be less or equal to ${selectedOrders[i].orderQty}`, 'right');
            this.commonService.implementToast(`${selectedOrders[i].stockcode}'s quantity must be less or equal to ${selectedOrders[i].orderQty}`, 'Info');
            return false;
          }
        }
      }


      // let count = 0;
      // let zeroQty = 0;
      // for (let i = 0; i < this.originalOrders.length; i++) {
      //   if (this.originalOrders[i].selected) {
      //     count++;
      //   }
      //   if (this.originalOrders[i].selected && Number(this.originalOrders[i].returnQty) === 0) {
      //     zeroQty++;
      //   }
      // }
      // if (count === 0) {
      //   this.commonService.implementToast(`must select at least one return item`, 'Info');
      //   return false;
      // }
      // if (zeroQty > 0) {
      //   this.commonService.implementToast(`If a line has been selected for partial return, qty field must be greater than zero`, 'Info');
      //   return false;
      // }


      // this.originalOrders.forEach((x) => {
      //   if (x.returnQty > x.orderQty) {
      //     this.commonService.showError(`#qty${x.stockcode}`, `Quantity must be less or equal to ${x.orderQty}`, 'right');
      //     return false;
      //   }
      // });
      // for (let i = 0; i < this.originalOrders.length; i++) {
      //   if (this.originalOrders[i].returnQty > this.originalOrders[i].orderQty) {
      //     //console.log(`${this.originalOrders[i].returnQty} > ${this.originalOrders[i].orderQty}`);
      //     this.commonService.implementToast(` ${this.originalOrders[i].stockcode}' return quantity  must be less or equal to ${this.originalOrders[i].orderQty}`, 'Info');
      //     return false;
      //   }
      // }
    }

    if (!this.orderNumber) {
      //this.commonService.showError('#inputOrderNumber', 'Please enter order number', 'right');
      this.commonService.implementToast('Please enter order number', 'Info');
      return false;
    }

    if (this.selectedReason === 'Please select') {
      this.commonService.implementToast('Please select an reason', 'Info');
      //this.commonService.showError('#reasonsDropDown', 'Please select an reason', 'right');
      return false;
    }


    if (this.selectedCondition === 'Please select') {
      this.commonService.implementToast('Please select an goods condition', 'Info');
      //this.commonService.showError('#conditionsDropDwon', 'Please select an goods condition', 'right');
      return false;
    }

    if (this.returnOption === '') {
      this.commonService.implementToast('Please select an return option', 'Info');
      //this.commonService.showError('#conditionsDropDwon', 'Please select an goods condition', 'right');
      return false;
    }

    return true;
  }

  stringToNumber(txt:string, toType:string){
    return toType == 'int' ? parseInt(txt) : parseFloat(txt);
  }
  
  deleteAttachment() {
    this.chooseFileMessage = 'No file chosen';
    this.formData.delete(this.imageFile.name);
    this.imageFile = null;
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  close() {
    this.router.navigate(['./'], {relativeTo: this.activatedRouter.parent});
  }


}
